module.exports = __webpack_public_path__ + "img/flutterwave_logo_color@2x.f9e74d8d.png";